export class GoogleWorkspaceWholeUserRestore {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "users",
            "baseName": "users",
            "type": "Array<GoogleWorkspaceUserRestoreSelection>",
            "format": ""
        },
        {
            "name": "workloads",
            "baseName": "workloads",
            "type": "Array<GoogleWorkspaceRestoreWorkload>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceWholeUserRestore.attributeTypeMap;
    }
    constructor() {
    }
}
